import React, { Component } from 'react'
import { connect } from 'react-redux'
import PurchaseCorrectionSample from '../samples/PurchaseCorrectionSample'
import { makePurchaseCorrection } from '../../../actions/mcpActions'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    
    order_ID: ["mcpPurchaseCorrection.SetOrderId(order_id);", "mcpPurchaseCorrection.setOrderId(order_id);", "'order_id'=>$order_id"],
    transaction_number: ["mcpPurchaseCorrection.SetTxnNumber(txn_number);", "mcpPurchaseCorrection.setTxnNumber(txn_number);", "'txn_number'=>$txn_number"],
    electronic_commerce_indicator: ["mcpPurchaseCorrection.SetCryptType(crypt);", "mcpPurchaseCorrection.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    
    customer_ID: ["mcpPurchaseCorrection.SetCustId(cust_id);", "mcpPurchaseCorrection.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["mcpPurchaseCorrection.SetDynamicDescriptor(dynamic_descriptor);", "mcpPurchaseCorrection.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
}


export class PurchaseCorrection extends Component {
    onMakePurchaseCorrectionPress() {
        const { storeId, apiToken, orderId, txnNumber, preAuthCompSuccess, purchaseSuccess } = this.props;
        if(txnNumber !== 'none' && (preAuthCompSuccess || purchaseSuccess)) {
            const purchaseCorrectionRequest = { storeId, apiToken, orderId, txnNumber };
            this.props.makePurchaseCorrection(purchaseCorrectionRequest);
        }
    }

    renderBtn() {
        const { txnNumber, preAuthCompSuccess, purchaseSuccess } = this.props;
        if(txnNumber !== 'none' && (preAuthCompSuccess || purchaseSuccess)) {
            return (
                <div className="requestButton" onClick={() => this.onMakePurchaseCorrectionPress()}>
                    MCP Purchase Correction Request
                </div> 
            );
        }
        else {
            return (
               <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                    <div className="disabledButton">
                        MCP Purchase Correction Request
                    </div>
                    <i style={{marginLeft: '1vw', fontSize: '0.8rem', color: 'red'}}>* To make this request you need to make a successful Purchase/Pre-Auth Completion request.</i>
               </div>
            );
        }
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample MCP Purchase Correction</h3>
                <PurchaseCorrectionSample />
                {this.renderBtn()}
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Purchase Correction</b></span>
                <p style={{marginTop: '3vh'}}>Restores the full amount of a previous MCP Purchase or MCP Pre-Authorization Completion transaction to the cardholder's card, and removes any record of it from the cardholder's statement.</p>
                <p>This transaction can be used against a Purchase or Pre-Authorization Completion transaction that occurred same day provided that the batch containing the original transaction remains open.</p>
                <p>MCP processing uses the automated closing feature, and Batch Close occurs daily between 10 and 11 pm Eastern Time.</p>
                <p>This transaction request is the multi-currency pricing (MCP) enabled version of the equivalent financial transaction.</p>

                <p><b>MCP Purchase Correction transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>MCPPurchaseCorrection mcpPurchaseCorrection = new MCPPurchaseCorrection();</code>
                    case _JAVA:
                        return <code>MCPPurchaseCorrection mcpPurchasecorrection = new MCPPurchaseCorrection();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_purchasecorrection', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for MCP Purchase Correction transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpPurchaseCorrection);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mcpPurchaseCorrection);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Purchase Correction transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>transaction number</td>
                        <td><i>String</i><br /><br />255-character, alphanumeric, hyphens or underscores<br /><br />variable length</td>
                        <td><code>{CODES.transaction_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>MCP Purchase Correction transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>dynamic descriptor</td>
                        <td><i>String</i><br /><br />20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, txnNumber } = state.mcp.main.config;
    const { preAuthCompSuccess, purchaseSuccess } = state.mcp.main;
    return { preAuthCompSuccess, purchaseSuccess, mode, storeId, apiToken, orderId, txnNumber, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makePurchaseCorrection})(PurchaseCorrection)
